import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

export interface IMobileMenuStateEvent {
    newMenuState: boolean;
}

@Component({
    selector: 'viega-header',
    templateUrl: './viega-header.component.html',
    styleUrls: ['./viega-header.component.scss'],
})
export class ViegaHeaderComponent {
    @Input()
    public titleHref: string = "javascript:location.reload()";

    @Input()
    public logoRouterLink: any = ['/'];

    @Input()
    public logoRouterLinkQueryParams: {};

    @Input()
    public appTitle: string;

    @Input()
    public pageTitle: string;

    /** 'desktop-only' or 'mobile-only' or 'always' */
    @Input()
    public pageTitleMode: string = "mobile-only";

    @Input()
    public disableBurgerMenu: boolean;

    /** 'mobile' or 'desktop' or false */
    @Input()
    public forceMode: boolean = false;

    public isMobileMenuExpanded: boolean;

    @Output()
    public mobileMenuStateChanged: EventEmitter<IMobileMenuStateEvent>
        = new EventEmitter<IMobileMenuStateEvent>();

    public setSidebarStatus(newStatus: boolean) {
        this.isMobileMenuExpanded = newStatus;
        this.mobileMenuStateChanged.emit({ newMenuState: newStatus });
    }
}



// WEBPACK FOOTER //
// ./src/viega-common/components/viega-header/viega-header.component.ts